<template>
  <v-container >
    <entity-properties-row :label="$t('siteNotification.type')"
                           :property="siteNotification.type | siteNotificationType"/>

    <entity-properties-row :label="$t('siteNotification.title')"
                           :property="siteNotification.title"/>

    <entity-properties-row :label="$t('siteNotification.message')">
      <preformatted-text-view v-model="siteNotification.message"/>
    </entity-properties-row>

    <entity-properties-row :label="$t('siteNotification.active')"
                           :property="siteNotification.active | siteNotificationActive"/>


    <entity-properties-row :label="$t('siteNotification.startTime')"
                           :property="siteNotification.startTime | date"/>

    <entity-properties-row :label="$t('siteNotification.endTime')"
                           :property="siteNotification.endTime | date"/>

    <slot name="append"></slot>
  </v-container>
</template>

<script>
import EntityPropertiesRow from '@/components/entity-crud/EntyPropertiesRow';
import PreformattedTextView from '@/components/layouts/PreformattedTextView';

export default {
  name: 'SiteNotificationPropertiesView',
  components: { PreformattedTextView, EntityPropertiesRow },
  props:{
    siteNotification: {
      required:true,
      type: Object,
    },
  },
};
</script>

<style scoped>

</style>
